import { render } from "./alertDialog.vue?vue&type=template&id=a6c0a7d2&scoped=true"
import script from "./alertDialog.vue?vue&type=script&lang=js"
export * from "./alertDialog.vue?vue&type=script&lang=js"

import "./alertDialog.vue?vue&type=style&index=0&id=a6c0a7d2&scoped=true&lang=css"

import exportComponent from "/home/wido/Documents/Project/SS-GreedGreed/ss-web-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6c0a7d2"]])

export default __exports__